const TZ = "Africa/Kampala";

export const NEXT_GATHERING_LABEL = "Next worship overnight";
export const NEXT_GATHERING_SUB = "Dates coming soon";

/** True when the public site has an ongoing or upcoming featured event date. */
export function hasFeaturedSchedule(content: {
  date: string;
  eventPhase?: "ongoing" | "upcoming" | null;
  brandingSource?: "active" | "latest-past" | "default";
}): boolean {
  if (content.eventPhase === "ongoing" || content.eventPhase === "upcoming") {
    return true;
  }
  if (content.brandingSource === "latest-past") return false;
  return Date.parse(content.date) > Date.now();
}

export function formatWeekdayInKampala(dateIso: string): string {
  return new Intl.DateTimeFormat("en-GB", { weekday: "long", timeZone: TZ }).format(
    new Date(dateIso),
  );
}

export function formatOrdinalDayInKampala(dateIso: string): { day: string; sup: string } {
  const parts = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    timeZone: TZ,
  }).formatToParts(new Date(dateIso));
  const dayNum = Number(parts.find((p) => p.type === "day")?.value ?? "1");
  const v = dayNum % 100;
  let sup = "TH";
  if (v < 11 || v > 13) {
    switch (dayNum % 10) {
      case 1:
        sup = "ST";
        break;
      case 2:
        sup = "ND";
        break;
      case 3:
        sup = "RD";
        break;
      default:
        sup = "TH";
    }
  }
  return { day: String(dayNum), sup };
}

export function formatMonthYearKampala(dateIso: string): string {
  return new Intl.DateTimeFormat("en-GB", {
    month: "long",
    year: "numeric",
    timeZone: TZ,
  }).format(new Date(dateIso));
}

export function formatHomeFeatureNightTitle(dateIso: string): string {
  const d = new Date(dateIso);
  const mo = new Intl.DateTimeFormat("en-US", { month: "short", timeZone: TZ }).format(d);
  const day = new Intl.DateTimeFormat("en-GB", { day: "numeric", timeZone: TZ }).format(d);
  return `${mo} ${day} · Overnight`;
}

export function formatMarqueeChip(dateIso: string): string {
  const d = new Date(dateIso);
  const mo = new Intl.DateTimeFormat("en-US", { month: "short", timeZone: TZ }).format(d);
  const day = new Intl.DateTimeFormat("en-GB", { day: "numeric", timeZone: TZ }).format(d);
  const year = new Intl.DateTimeFormat("en-GB", { year: "numeric", timeZone: TZ }).format(d);
  return `${mo} ${day} · ${year}`;
}

export function formatStreamTimeLine(dateIso: string): string {
  const d = new Date(dateIso);
  const datePart = new Intl.DateTimeFormat("en-GB", {
    month: "short",
    day: "numeric",
    timeZone: TZ,
  }).format(d);
  const timePart = new Intl.DateTimeFormat("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: TZ,
  }).format(d);
  return `${datePart}, ${timePart} EAT`;
}

export function formatShortOvernightFooter(dateIso: string): string {
  const d = new Date(dateIso);
  const mo = new Intl.DateTimeFormat("en-US", { month: "short", timeZone: TZ }).format(d);
  const day = new Intl.DateTimeFormat("en-GB", { day: "numeric", timeZone: TZ }).format(d);
  return `${mo} ${day} Overnight`;
}

export function formatRsvpThanksLine(dateIso: string): string {
  const d = new Date(dateIso);
  const wd = new Intl.DateTimeFormat("en-GB", { weekday: "long", timeZone: TZ }).format(d);
  const rest = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: TZ,
  }).format(d);
  return `See you on ${wd}, ${rest}.`;
}
